import { SlotAllocationsTable } from './slot-allocations-table';
import { EntitySlotSummary } from './entity-slot-summary';

interface SlotAllocationsTabProps {
  entityId: number;
}

export const SlotAllocationsTab = ({ entityId }: SlotAllocationsTabProps) => {
  return (
    <>
      <EntitySlotSummary entityId={entityId} displayMode="nris" />
      <SlotAllocationsTable entityId={entityId} />
    </>
  );
};
